import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " Are you sure you want to delete this export? ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "This action is irreversible.", -1)
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = value => _ctx.$emit('update:modelValue', value)),
    title: "Delete export"
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("button", {
        class: "button",
        onClick: close
      }, "Cancel", 8, _hoisted_4),
      _createElementVNode("button", {
        class: _normalizeClass(["button is-danger", { 'is-loading': _ctx.loading }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteExport && _ctx.deleteExport(...args)))
      }, " Delete ", 2)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["model-value"]))
}